<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <b-table
            id="products-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{ afterResize: columnsWidthChanged }"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(description)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(report_to_onjn)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(z_include)="data">{{
              $t(data.label)
            }}</template>

            <template v-slot:cell(code)="data">
              <i
                v-if="data.value"
                class="flag-icon"
                :class="
                  'flag-icon-' + (data.value ? data.value.toLowerCase() : '')
                "
              />
            </template>
            <template v-slot:cell(report_to_onjn)="data">{{
              data.value ? $t("YES") : $t("NO")
            }}</template>
            <template v-slot:cell(z_include)="{ value }">{{
              value ? $t("YES") : $t("NO")
            }}</template>

            <template v-slot:head(selected)>
              <label
                class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid"
              >
                <input
                  type="checkbox"
                  @click.stop
                  @change="selectAll"
                  v-model="checkAll"
                />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label
                class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid"
              >
                <input
                  type="checkbox"
                  @click.stop
                  :value="data.item.eid"
                  v-model="selected"
                />
                <span></span>
              </label>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                  >{{ $t("Apply") }}</b-button
                >
                <span class="pagination-sep" v-if="selected.length"></span>

                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'products-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    BulkActionSelect
  },
  name: "products",
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "products",

      bulkAction: null,
      bulkActionOptions: [],

      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          ignore: true,
          class: "d-none"
        },
        { key: "name", sortable: true, class: "" },
        { key: "description", sortable: false, class: "", ignore: true },
        {
          key: "report_to_onjn",
          label: "Report To Onjn",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "z_include",
          label: "Z Include",
          sortable: false,
          class: "",
          ignore: true
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "Add product"
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "products-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("product/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.$root.$emit("bv::refresh::table", "products-table");
      });
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      this.$store
        .dispatch("product/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          resp.data.rows.forEach((item, index) => {
            resp.data.rows[index].code = item.iso2;
          });
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/products/" + item.eid);
    },
    redirect() {
      this.$router.push("/products/0");
    }
  }
};
</script>

<style lang="scss" scoped></style>
